<template>

    <div class="pqcescheck-container">
        <div class="left">
            <vggrid ref="xGrid" :random="Math.floor(Math.random() * 999999)" class="vggrid" :list="pusComList" flexname=""
                    :cols="cols"
                    :showfooter="false"
                    :showPage="false" :resizable="true"
                    @cellClick="cellClick">
            </vggrid>
        </div>
        <div class="right" v-if="psu">

            <div class="right-grid">
                <vggrid :list="pqciemcheckList" flexname="" :cols="pqcCols"
                        :showfooter="false" :showPage="false" :resizable="true" :mergeRow='mergeRow'
                >
                    <template slot="btn">
                        <div class="right-template">
                            <div class="right-container">
                                <div class="right-label">供应商：</div>
                                <div class="right-value">{{psu.comfullname}}</div>
                                <div class="right-label" v-if="psu.prsflg === '1'">竞价方案：</div>
                                <div class="right-label" v-if="psu.prsflg === '2'">开标方案：</div>
                                <div class="right-value"><span @click="downFile(psu.appendurl)">{{psu.appendfilename}}</span></div>
                            </div>
                        </div>
                    </template>
                </vggrid>
            </div>
            <div v-if="pqciemcheckList.length">
                <div class="right-box">
                    <div class="right-container">
                        <div class="right-label">检查结果：</div>
                        <div class="right-value">{{psupqcesresultdesc || ''}}</div>
                        <div class="right-label">检查意见：</div>
                        <div  class="right-content" v-if="isEdit">
                            <el-input v-model="psu.psupqcescdesc" type="textarea" :maxlength="255" show-word-limit></el-input>
                        </div>
                        <div class="right-content"  v-if="!isEdit">
                            {{psu.psupqcescdesc}}
                        </div>
                        <div class="right-btn"  v-if="isEdit">
                            <vxe-button type='primary' class="vxe-btn" @click="save" :loading="btnLoading">保存</vxe-button>
                        </div>
                    </div>
                </div>
                <div class="right-grid">
                    <vggrid :list="pqcesList" flexname="" :cols="pqcesCols"
                            :showfooter="false" :showPage="false" :resizable="true"
                    >
                        <template slot="btn">
                            <div class="right-bottom">
                                <div class="right-bottom-title">项目初审检查最终结论</div>
                                <div class="right-bottom-btn" v-if="isEdit">
                                    <vxe-button type='primary' class="vxe-btn" @click="submit" :loading="btnLoading">提交</vxe-button>
                                </div>
                            </div>
                        </template>
                    </vggrid>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import common from '@/mixin/common'
  import utils from '../../assets/js/utils'

  export default {
    name: 'exPqcCheckComIndex',
    props: {
      projectid: {},
      activeName: {}
    },
    mixins: [common],
    data () {
      return {
        project:{},
        pqciemcheckList: [],
        pqcesList: [],
        list: [],
        btnLoading: false,
        psu: '',
        isEdit: true,
        pqcitemcheckresult: '',
        mergeRow:['ind','pqcitemchecktypedesc'],
        pqcesCols: [
          {field: 'comfullname', fieldtype: 'C', title: '投标人', calculExpr: '', addNewRowFlg: false},
          {field: 'pqcesresultdesc', fieldtype: 'C', title: '检查结果', calculExpr: '', addNewRowFlg: false, width: 100},
          {field: 'pqcescdesc', fieldtype: 'C', title: '检查意见', calculExpr: '', addNewRowFlg: false},
        ],
        pqcCols: [
          {field: 'pqcitemchecktypedesc', fieldtype: 'C', title: '初审分类', calculExpr: '', addNewRowFlg: false, width: 100},
          {field: 'pqcitemcheckcontent', fieldtype: 'C', title: '初审内容', calculExpr: '', addNewRowFlg: false},
          // {field: 'pqcitemcheckdemand', fieldtype: 'C', title: '采购文件要求', calculExpr: '', addNewRowFlg: false},
          {
            title: '结果', width: 160, showOverflow: true,
            slots: {
              default: 'default',
              default: ({row}) => {
                if (this.isEdit) {
                  return [
                    <input type="radio" name={row.pqcitemcheckid+''} checked={row.checked_1} onChange={this.radioChange.bind(this, row)} value="1"/>,"通过",
                <span style="padding-left: 15px"><input type="radio" name={row.pqcitemcheckid+''} checked={row.checked_2} onChange={this.radioChange.bind(this, row)} value="2"/></span>,"不通过"
                  //   <vxe-radio name={row.pqcitemcheckid+''} label="1" onChange={this.radioChange.bind(this, row)}>通过</vxe-radio>,
                  // <vxe-radio name={row.pqcitemcheckid+''} label="2" onChange={this.radioChange.bind(this, row)}>不通过</vxe-radio>
                ]
                } else {
                  return +row.pqcitemcheckresult === 1 ? '通过':'不通过'
                }
              }
            }
          }
        ],
        cols: [
          {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 50},
          {field: 'comfullname', fieldtype: 'C', title: '供应商', calculExpr: '', addNewRowFlg: false, width: 200}
          // {
          //   title: '附件', width: 160, showOverflow: true,
          //   slots: {
          //     default: 'default',
          //     default: ({row}) => {
          //       return [
          //         < a
          //       style = "color: #2f74ff;cursor: pointer;"
          //       onClick = {this.download.bind(this, row)
          //     }>
          //       {
          //         row.appendfilename
          //       }
          //     <
          //       /a>
          //     ]
          //     }
          //   }
          // }
        ],
        pusComList: []
      }
    },
    deactivated () {
      this.$destroy()
    },
    created () {
      this.getModel()
      this.getPsuComList()
    },
    activated () {
      this.getPsuComList()
    },
    mounted () {
    },
    watch: {
      activeName () {
        console.log(this.activeName)
        if(this.activeName === 'agys') {
          this.getPsuComList()
        }
      }
    },
    components: {vggrid},
    methods: {
      // 结果汇总表的提交
      async submit () {
        let index = this.pqcesList.findIndex(v => !v.pqcesresultdesc)
        if (index > -1) {
          this.$message.warning('请先进行资格性/符合型检查!')
          return
        }
        this.$confirm('检查完成，提交后，不允许再次检查?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(async() => {
          let data = await request({
            url: 'expert/insertPqces',
            method: "post",
            data: {
              pexpertid: this.$store.getters.expertLoginUser.pexpertid,
              projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
              list: this.pqcesList
            }
          })
          if (data.issuccess === 1) {
            this.$message.success('保存成功')
            this.isEdit = false
            this.$emit('change')
          } else {
            this.$message.error('保存失败')
          }
        })
      },
      // 检查结果保存
      async save () {
        if (!this.psupqcesresultdesc) {
          this.$message.warning('请先进行资格性/符合型检查!')
          return
        }
        let data = await request({
          url: 'expert/updatePqcIemCheck',
          method: "post",
          data: {
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            pqccheckusertype: +this.psu.prsflg === 1 ? 1 : 2,
            list: this.pqciemcheckList
          }
        })
        if (data.issuccess === 1) {
          this.$message.success('保存成功')
          this.pqcesList.forEach(v => {
            if (+v.pqcescomid === +this.psu.psucomid) {
              v.pqcesresultdesc = this.psupqcesresultdesc
              v.pqcesresult = this.psu.psupqcesresult
              v.pqcescdesc = this.psu.psupqcescdesc
              v.pqcesexpertid = this.$store.getters.expertLoginUser.pexpertid
              v.pqcesusertpye = +this.psu.prsflg === 1 ? 1:2
            }
          })
        } else {
          this.$message.error('保存失败')
        }
      },
      radioChange (row, e) {
        console.log(e)
        row.pqcitemcheckresult = e.target.value
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
        await this.initPqcitemcheck()
      },
      // 左边供应商清单数据
      async getPsuComList () {
        this.psu = ''
        let res = await request({
          url: 'expert/getPsuListByPIdHaveAppend',
          method: "get",
          params: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid
          }
        })
        this.pusComList = res.data
        // await this.initPqcitemcheck()
        this.psu = this.pusComList[0]
        this.$refs.xGrid.$refs.xGrid.setCurrentRow(this.psu)
        await this.getpqcList()
        await this.getPqcesList()
        if (this.pqcesList.length) {
          this.isEdit = false
        } else {
          this.isEdit = true
          this.pqcesList = this.pusComList.map(v => {
            return {
              psuid: v.psuid,
              pqcescomid: v.psucomid,
              comfullname: v.comfullname,
              pqcesprojectid: v.psuprojectid,
              pqcesresult: null,
              pqcesresultdesc: null,
              pqcescdesc: null,
              pqccheckexpertid: null,
              pqcesusertpye: null
            }
          })
        }
      },
      // async initPqcitemcheck () {
      //   await request({
      //     url: 'expert/insertPqcitemcheck',
      //     method: "post",
      //     data: {
      //       projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
      //       pexpertid: this.$store.getters.expertLoginUser.pexpertid
      //     }
      //   })
      // },
      // 结果汇总表的数据
      async getPqcesList () {
        this.pqcesList = await request({
          url: 'expert/getPqcesByProjectId',
          method: "get",
          params: {
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid
          }
        })
      },
      // 供应商清单行点击
      async cellClick (row) {
        this.psu = row.row
        this.getpqcList()
      },
      // 右边检查项清单数据
      async getpqcList () {
        this.pqciemcheckList = []
        this.loading = true
        let res = await request({
          method: 'get',
          url: 'expert/getPqcListByComId',
          params: {
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            comid: this.psu.psucomid,
            projectid: this.psu.psuprojectid
          }
        })
        this.pqciemcheckList = res
        this.loading = false
        this.pqciemcheckList = this.pqciemcheckList.map(v => {
          if (+v.pqcitemcheckresult === 1) {
            v.checked_1 = true
          }
          if (+v.pqcitemcheckresult === 2) {
            v.checked_2 = true
          }
          return v
        })
      }
    },
    filters: {},
    computed: {
      // 返回评审人对供应商的某一项检查结果值
      psupqcesresultdesc () {
        let list = this.pqciemcheckList.filter(v => +v.pqcitemcheckresult === 1)
        let faile = this.pqciemcheckList.filter(v => +v.pqcitemcheckresult === 2)
        if (list.length === this.pqciemcheckList.length && !faile.length) {
          this.psu.psupqcesresult = 1
          return '通过'
        } else {
          if ((faile.length + list.length) === this.pqciemcheckList.length) {
            let index = this.pqciemcheckList.findIndex(v => +v.pqcitemcheckresult === 2)
            if (index >= 0) {
              this.psu.psupqcesresult = 2
              return '不通过'
            } else {
              return ''
            }
          } else {
            return  ''
          }
        }
      }
    }
  }
</script>
<style lang="scss">
    .pqcescheck-container {
        display: flex;
        .left {
            width: 250px;
            margin-right: 15px;
        }
        .right {
            flex: 1;
            .right-template {
                padding-left: 10px;
                .right-container {
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    .right-value {
                        padding: 0 50px 0 0;
                        color: #999999;
                        span {
                            display: block;
                            color: #409EFF;
                            cursor: pointer;
                        }
                    }
                }
            }
            .right-box {
                border: 1px solid #E4E7ED;
                border-radius: 2px;
                padding: 15px;
                margin-bottom: 20px;
                .right-container {
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    .right-label {

                    }
                    .right-value {
                        padding: 0 50px 0 0;
                        color: #999999;
                        span {
                            display: block;
                            color: #409EFF;
                            cursor: pointer;
                        }
                    }
                    .right-content {
                        width: 500px;
                        color: #999999;
                    }
                    .right-btn {
                        padding-left: 20px;
                    }
                }
            }
            .right-grid{
                padding-bottom: 20px;
            }
            .right-bottom {
                display: flex;
                align-items: center;
                .right-bottom-title {
                    padding-left: 10px;
                    text-align: center;
                }
                .right-bottom-btn {
                    padding-left: 20px;
                }
            }
        }
    }
</style>
